import React from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Button, Paper, Typography, useMediaQuery, useTheme } from '@mui/material';

import {
  PET_LIABILITY_AFFECTED_PARTY,
  PET_LIABILITY_REASON,
  useNewPetLiabilityFormDataValue,
} from '../../claimFormData/newClaimFormDataPetLiability';
import {
  useUploadDocumentPetLiabilityBackButtonLink,
  useUploadDocumentPetLiabilityNextButtonLink,
} from './useUploadDocumentPetLiability';

import FileUploader from './FileUploader';
import FileList from './FileList';
import { BackButton, PageTitle } from '../../../../components/common';
import ButtonContainer from '../../../../components/ButtonContainer';

import { StyledVerticalContent } from './FileUploader.styled';

function UploadDocumentPetLiability(props) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('desktop'));

  const [liabilityReason] = useNewPetLiabilityFormDataValue(PET_LIABILITY_REASON);

  const [affectedParty] = useNewPetLiabilityFormDataValue(PET_LIABILITY_AFFECTED_PARTY);

  const { selectedDocuments, setSelectedDocuments } = props;

  const history = useHistory();

  const validSelectedDocuments = Array.isArray(selectedDocuments)
    ? selectedDocuments.filter((d) => d?.valid)
    : [];

  const backButtonLink = useUploadDocumentPetLiabilityBackButtonLink(
    liabilityReason,
    affectedParty
  );
  const nextButtonLink = useUploadDocumentPetLiabilityNextButtonLink();

  const addFileHandler = (currFiles) => {
    setSelectedDocuments((state) => [...state, ...currFiles]);
  };

  const removeFileHandler = (ev, id) => {
    if (ev) {
      ev.preventDefault();
      ev.stopPropagation();
    }

    const updatedFileList = selectedDocuments?.filter((item) => item?.fileId !== id);
    setSelectedDocuments(updatedFileList);
  };

  const handleNextStep = () => {
    history.push(nextButtonLink);
  };

  const hasFiles = selectedDocuments?.length > 0;

  return (
    <>
      <BackButton
        label={
          <Typography variant="h3">
            <FormattedMessage id="common.button.back" />
          </Typography>
        }
        to={backButtonLink}
      />

      <PageTitle>
        <Typography variant="h1">
          <FormattedMessage
            id={
              hasFiles
                ? 'new_claim.upload.page.title.with.files'
                : 'new_claim.upload.page.title.without.files'
            }
          />
        </Typography>
      </PageTitle>

      <StyledVerticalContent>
        {!hasFiles && (
          <Typography variant="p">
            <FormattedMessage id="pet_liability.new_claim.upload_document.page.description" />
          </Typography>
        )}

        {hasFiles && (
          <Paper>
            <FileList files={selectedDocuments} onRemove={removeFileHandler} />
          </Paper>
        )}

        <Paper>
          <FileUploader
            descriptionIdWithFiles="pet_liability.new_claim.upload_document.file_uploader.description_with_files"
            selectedFiles={selectedDocuments}
            setSelectedFiles={addFileHandler}
          />

          {isDesktop && hasFiles && (
            <ButtonContainer>
              <Button onClick={handleNextStep} disabled={!validSelectedDocuments.length}>
                <Typography variant="buttons">
                  <FormattedMessage id="common.button.next" />
                </Typography>
              </Button>
            </ButtonContainer>
          )}
        </Paper>
      </StyledVerticalContent>

      {!isDesktop && hasFiles && (
        <ButtonContainer>
          <Button onClick={handleNextStep} disabled={!validSelectedDocuments.length}>
            <Typography variant="buttons">
              <FormattedMessage id="common.button.next" />
            </Typography>
          </Button>
        </ButtonContainer>
      )}
    </>
  );
}

export default UploadDocumentPetLiability;
